/**
 * Deja las columnas con `meta.sticky === 'right'` siempre al final del orden,
 * manteniendo el orden relativo entre ellas.
 *
 * @param {string[]} order orden actual (ids de columnas hoja).
 * @param {string[]} leafIds todos los ids en orden de definicion.
 * @param {string[]} stickyRightIds ids que deben ir pegados a la derecha.
 */
export const pinStickyRightColumns = (order, leafIds, stickyRightIds) => {
	if (!stickyRightIds?.length) return order?.length ? order : leafIds;

	const stickySet = new Set(stickyRightIds);
	const base = order?.length ? order : leafIds;

	const nonStickyOrdered = base.filter((id) => leafIds.includes(id) && !stickySet.has(id));
	const missingNonSticky = leafIds.filter((id) => !stickySet.has(id) && !nonStickyOrdered.includes(id));
	const tail = stickyRightIds.filter((id) => leafIds.includes(id));

	return [...nonStickyOrdered, ...missingNonSticky, ...tail];
};

export const getStickyRightIdsFromColumns = (columns = []) =>
	columns.filter((c) => c.meta?.sticky === 'right').map((c) => c.id ?? c.accessorKey).filter(Boolean);

export const getLeafIdsFromColumns = (columns = []) =>
	columns.map((c) => c.id ?? (typeof c.accessorKey === 'string' ? c.accessorKey : String(c.accessorKey))).filter(Boolean);

/**
 * Cuenta columnas hoja visibles según `view.columnVisibility` y `view.columnOrder`
 * (misma lógica de orden que la tabla con sticky a la derecha).
 */
export const countVisibleLeafColumns = (columns = [], view = {}) => {
	const leafIds = getLeafIdsFromColumns(columns);
	const stickyRightIds = getStickyRightIdsFromColumns(columns);
	const columnOrder = pinStickyRightColumns(
		view.columnOrder?.length ? view.columnOrder : leafIds,
		leafIds,
		stickyRightIds,
	);
	const visibility = view.columnVisibility || {};
	let n = 0;
	for (const id of columnOrder) {
		if (!leafIds.includes(id)) continue;
		if (visibility[id] === false) continue;
		n += 1;
	}
	return n;
};
